export default __webpack_public_path__ + "static/media/Make-in-India-Logo.63332318.jpg";